import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadIndustries } from "../Industries/loadData";
import { AddProfileInformation } from "./addProfileInformation";
import { loadLookupsList, loadLookupsTypes } from "./loadData";
import { lookupListHeaders } from "./tableHeaders";

const ProfileInformation = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [lookupsList, setLookupsList] = useState([]);
  const [lookupsTypes, setLookupsTypes] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);

  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [industries, setIndustries] = useState([]);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadLookupsList(setLoading).then(setLookupsList);
    loadLookupsTypes(setLoading).then(setLookupsTypes);
    loadIndustries(setLoading).then(setIndustries);
  }, [location.pathname, update]);

  const filteredLookupsList = lookupsList?.filter(
    (lookup) =>
      lookup.lookupType === "employmentStatus" ||
      lookup.lookupType === "jobType"
  );
  console.log("filteredLookupsList", filteredLookupsList);
  let newLookupsTypes = ["industry"];
  const filteredLookupsTypes = lookupsTypes?.filter(
    (lookupType) =>
      lookupType === "employmentStatus" || lookupType === "jobType"
  );
  filteredLookupsTypes.push(...newLookupsTypes);
  console.log("OUR FILTERED LOOKUPS TYPES", filteredLookupsTypes);
  console.log("OUR FILTERED LOOKUPS", lookupsTypes);

  const allIndustries = industries?.map((industry) => ({
    lookupName: industry.industryName,
    _id: industry._id,
    lookupDescription: industry.industryDescription,
    createdDate: industry.createdDate,
    state: industry.state,
    lookupType: "industry",
  }));
  const allLookups = [...filteredLookupsList, ...allIndustries];
  allLookups.map((lookup, index) => {
    lookup.id = index + 1;
  });
  let url = "";
  if (deleteData?.lookupType === "industry") {
    url = `industry/deleteIndustry/${deleteData?._id}`;
  } else {
    url = `lookup/deleteLookup/${deleteData?._id}`;
  }
  return (
    <AdminPage title={"Profile Essentials"}>
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Profile Essentials"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.lookupName}
            type={viewModalData?.lookupType}
            description={viewModalData?.lookupDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Profile Essential"}
        InternalComponent={
          <DeleteModalContent
            route={url}
            type={"Profile Essentials"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddProfileInformation
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        lookupsTypes={filteredLookupsTypes}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={lookupListHeaders}
          rowData={allLookups}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalState={setViewModalState}
          setViewModalData={setViewModalData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default ProfileInformation;
